import { c as create_ssr_component, v as validate_component } from "./ssr.js";
import { T as Typeahead } from "./Typeahead.js";
const AsyncTypeAhead = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { id = "input-" + Math.random().toString(36) } = $$props;
  let { displayProperty = "name" } = $$props;
  let { label = "" } = $$props;
  let { value = "" } = $$props;
  let { call } = $$props;
  let { icon = "pen-solid" } = $$props;
  let { extract = (item) => item } = $$props;
  let collection = [];
  if ($$props.id === void 0 && $$bindings.id && id !== void 0) $$bindings.id(id);
  if ($$props.displayProperty === void 0 && $$bindings.displayProperty && displayProperty !== void 0) $$bindings.displayProperty(displayProperty);
  if ($$props.label === void 0 && $$bindings.label && label !== void 0) $$bindings.label(label);
  if ($$props.value === void 0 && $$bindings.value && value !== void 0) $$bindings.value(value);
  if ($$props.call === void 0 && $$bindings.call && call !== void 0) $$bindings.call(call);
  if ($$props.icon === void 0 && $$bindings.icon && icon !== void 0) $$bindings.icon(icon);
  if ($$props.extract === void 0 && $$bindings.extract && extract !== void 0) $$bindings.extract(extract);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Typeahead, "Typeahead").$$render(
      $$result,
      {
        id,
        displayProperty,
        label,
        icon,
        data: collection,
        extract,
        value
      },
      {
        value: ($$value) => {
          value = $$value;
          $$settled = false;
        }
      },
      {
        default: ({ item, index, value: value2 }) => {
          return `${slots.default ? slots.default({ item, index, value: value2 }) : ` <!-- HTML_TAG_START -->${item[displayProperty]}<!-- HTML_TAG_END --> `}`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
export {
  AsyncTypeAhead as A
};
//# sourceMappingURL=AsyncTypeAhead.js.map
